import { FunctionComponent } from 'react';

import { getFormattedDate } from 'utils/date';

import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';
import JobBoxDescription from 'components/modules/public/layout/jobs/JobBoxDescription';
import MediumJobBox from 'components/modules/public/layout/jobs/MediumJobBox';

import { Props } from './index';
import StyledComponent from './styles';

const PublicLayoutJobsJobBoxWithDescription: FunctionComponent<Props> = ({
    job,
    jobCity,
    jobBoxCopy,
    jobBoxDescriptionCopy,
    onApply,
    applicationButtonVisible,
}) => {
    return (
        <StyledComponent
            className="public-layout-jobs-job-box-with-description"
        >
            <LayoutContainer size={Sizes.Small}>
                <MediumJobBox
                    job={job}
                    jobCity={jobCity}
                    onApply={onApply}
                    {...jobBoxCopy}
                    applicationButtonVisible={applicationButtonVisible}
                />
                <JobBoxDescription
                    {...jobBoxDescriptionCopy}
                    job={job}
                    jobCity={jobCity}
                />
                <div className="job-meta-row">
                    {job?.createdAt && (
                        <div className="job-created-at">
                            {`Data dodania: ${getFormattedDate(job.createdAt, 'date')}`}
                        </div>
                    )}
                    <div className="job-source">
                        {job?.createSource === 'cbop' ? 'Źródło: oferty.praca.gov.pl' : 'Oferta Praca50+'}
                    </div>
                    {job?.createSource === 'cbop' && job?.cbopUrl && (
                        <a
                            className="job-source-link"
                            href={job.cbopUrl}
                            target="_blank"
                            rel="nofollow noopener"
                        >
                            Zobacz ofertę źródłową
                        </a>
                    )}
                </div>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicLayoutJobsJobBoxWithDescription;